var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMylearnings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 9.775,
    height: 12.256,
    viewBox: "0 0 9.775 12.256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_42250",
    "data-name": "Path 42250",
    d: "M4,4.444A2.444,2.444,0,0,1,6.444,2h4.887a2.444,2.444,0,0,1,2.444,2.444v8.588a1.222,1.222,0,0,1-1.932.994l-2.955-2.11L5.932,14.026A1.222,1.222,0,0,1,4,13.031ZM6.444,3.222A1.222,1.222,0,0,0,5.222,4.444v8.588L8.177,10.92a1.222,1.222,0,0,1,1.42,0l2.955,2.111V4.444a1.222,1.222,0,0,0-1.222-1.222Z",
    transform: "translate(-4 -2)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylearnings);
export default __webpack_public_path__ + "static/media/Mylearnings.426d117d1ae695ffdb6e841294c27a24.svg";
export { ForwardRef as ReactComponent };